import type { SecondaryMarketAmendLimitOrderFetched } from 'state/secondaryMarket/limit-order/form/original/original.actions';
import { originalFormReducerFactory } from 'state/secondaryMarket/shared/form/original/original.reducer';

import { initialLimitOrderReloadedFormMap } from './original.model';

export const limitOrderOriginalFormReducer = originalFormReducerFactory(
  'LIMIT_ORDER',
  initialLimitOrderReloadedFormMap,
  'limitOrder',
  (action: SecondaryMarketAmendLimitOrderFetched) => ({
    limit: action.data.clientLimit,
    salesMarginAdjustment: action.data.salesMarginAdjusted,
  }),
);
